import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Unlock = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Unlock' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M23,23 L23,11 L9,11 L9,23 L23,23 Z M14,17 L18,17 M11,11 L11,7 C11,4 11,1 6,1 C1,1 1,4 1,7 L1,11' />
  </StyledIcon>
);
